import { ApiError, RequestPayloadValidationError, ResponsePayloadValidationError } from '@hprofits/api-client/errors';
import { ZodError } from 'zod';

type Issue = Readonly<{ message: string }>;

const joinIssues = (issues: ReadonlyArray<Issue>): string | undefined => {
  const messages = [...new Set(issues.map((issue) => issue.message).filter((message) => message.length > 0))];
  return messages.length > 0 ? messages.join(', ') : undefined;
};

// What the server — or the write schema the payload is parsed with before sending — said, for screens
// that already own a headline. Transport errors return nothing: "Unexpected HTTP error" tells the user
// no more than the headline does.
export const readBlacklistErrorMessage = (error: unknown): string | undefined => {
  if (error instanceof ZodError) {
    return joinIssues(error.issues);
  }
  if (error instanceof RequestPayloadValidationError || error instanceof ResponsePayloadValidationError) {
    return joinIssues(error.validationError.issues);
  }
  if (error instanceof ApiError) {
    return error.message.length > 0 ? error.message : undefined;
  }
  return undefined;
};
